import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const allureReportFrontendPlugin = createPlugin({
  id: 'allure-report-frontend',
  routes: {
    root: rootRouteRef,
  },
});

export const allureReportPlugin = createPlugin({
  id: 'allure-report',
  routes: {
    root: rootRouteRef,
  },
});

export const AllureReportPageComponent = allureReportPlugin.provide(
  createRoutableExtension({
    name: 'AllureReportPage',
    component: () =>
      import('./components/AllureReportPage').then(m => m.StaticPagesViewer),
    mountPoint: rootRouteRef,
  }),
);
